import { toast } from "react-toastify";
import { GetContent } from "../../Services/MainServices";

export const FETCH_CONTENT_REQUEST = "FETCH_CONTENT_REQUEST";
export const FETCH_CONTENT_SUCCESS = "FETCH_CONTENT_SUCCESS";
export const FETCH_CONTENT_FAILURE = "FETCH_CONTENT_FAILURE";

export const fetchContent = (category) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CONTENT_REQUEST });
    const response = await GetContent(category);

    if (response.status === 200 || response.status === 201) {
      dispatch({
        type: FETCH_CONTENT_SUCCESS,
        payload: response.data.data,
      });
    } else {
      dispatch({
        type: FETCH_CONTENT_FAILURE,
        payload: `Unexpected response code: ${response.status}`,
      });
    }
  } catch (error) {
    let message = "Something went wrong";

    if (error.response) {
      const { status, data } = error.response;

      // Handle auth error (optional)
      if (status === 401 || status === 403) {
        message = "Unauthorized. Please login again.";
        // dispatch(logoutUser()); // optionally auto-logout
      } else {
        message =
          data?.message ||
          `Error ${status}: ${data?.detail || "Unexpected error"}`;
      }
    } else if (error.request) {
      message = "No response from server. Please check your network.";
    } else {
      message = error.message;
    }

    dispatch({
      type: FETCH_CONTENT_FAILURE,
      payload: message,
    });
  }
};
